<template>
  <section>
    <search :searchStatus="false"></search>
    <section class="padding-footer">
      <div class="util-detail-header">
        <div class="util-header-top">
          <div>
            <img src="@/assets/img/util-tab-4-title.svg" />
          </div>
          <div class="util-detail-header-title">
            <strong>Tambah Pencatatan Kue</strong>
          </div>
        </div>
        <span>Masukkan Catatan Sesuai Form</span>
      </div>
      <div class="illusion"></div>
      <b-container>
        <section style="padding-inline: 12px; padding-top: 8px">
          <ValidationObserver ref="observer">
            <b-form
              slot-scope="{ validate }"
              @submit.prevent="validate().then(submitTicket)"
            >
              <div style="display: flex; flex-direction: column; gap: 8px">
                <ValidationProvider rules="required" name="Suject">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <b-form-input
                    class="txt-input2"
                      v-bind:class="{ active: isActive }"
                      placeholder="Date"
                      v-model="date"
                      :state="errors[0] ? false : valid ? true : null"
                      @change="preview()"
                      @focus="toDate"
                      @blur="toText"
                      type="text"
                    ></b-form-input>
                    <b-form-invalid-feedback id="inputLiveFeedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider rules="required" name="Production">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <b-form-input
                      class="txt-input1"
                      v-bind:class="{ active: isActive }"
                      placeholder="Total Produksi (Box)"
                      v-model="production"
                      :state="errors[0] ? false : valid ? true : null"
                      @change="(e)=> {production = e ? parseFloat(e.slice(0, 10)).toLocaleString('en-US') : '';preview()}"
                      
                    ></b-form-input>
                    <b-form-invalid-feedback id="inputLiveFeedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </b-form>
          </ValidationObserver>
          
          <div class="util-totals">
            <div class="util-total">
              <span>Biaya Listrik / Box</span>
              <strong>{{ num(Math.floor(total1) ?? '0') }}</strong>
            </div>
            <div class="util-total">
              <span>Biaya Gas / Box</span>
              <strong>{{ num(Math.floor(total2) ?? '0') }}</strong>
            </div>
            <div class="util-total">
              <span>Biaya Air / Box</span>
              <strong>{{ num(Math.floor(total3) ?? '0') }}</strong>
            </div>
            <!-- <div class="util-total">
              <span>Biaya Per Box</span>
              <strong>{{ num(Math.floor(total4) ?? '0') }}</strong>
            </div> -->
            <div class="util-total">
              <span>Total Biaya / Box</span>
              <strong>{{ num(Math.floor(total) ?? '0') }}</strong>
            </div>
          </div>
        </section>
      </b-container>
    </section>
    <util-action @submit="submit"></util-action>
    <!-- <MenuFooter /> -->
  </section>
</template>
<script lang="js">
import dayjs from "dayjs";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Search from "@/components/Search.vue";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilAction from "@/views/pages/Utilities/Components/Util-Action.vue";
import { api, num } from "@/api/api";

@Component({
    components: {
        MenuFooter,
        Search,
        ValidationObserver,
        ValidationProvider,
        UtilAction
    },
})
export default class Utilities extends Vue {
  mounted() {
    let txtInput1 = document.querySelectorAll('.txt-input1')
    txtInput1.forEach((item) => {
      item.addEventListener('click', () => {
        item.select()
      })
      item.addEventListener('keydown', (e) => {
        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            (e.keyCode >= 35 && e.keyCode <= 39) ||
            (e.keyCode >= 112 && e.keyCode <= 123)) {
          return;
        }
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
        }
      })
    })
  }
    isActive = false
    errors = []
    toDate(e) {
      e.target.type = 'date'
    }
  toText(e) {
    if(!e.target.value){
      e.target.type = 'text'
    }
  }
    
  num = num

    date = dayjs().format("YYYY-MM-DD")
    production = null
    total = 0
    total1 = 0
    total2 = 0
    total3 = 0
    total4 = 0

    preview(){
      if (this.production) {
        let data = {
              "usage_date" : this.date,
              "production_total" : parseFloat(this.production.replace(/,/g, '')),
          }
        api('kue_preview',{body:data}).then(res => {
          if (res.code == 200) {
            this.total = res.data.total_biaya
            this.total1 = res.data.cost_electric
            this.total2 = res.data.cost_gas
            this.total3 = res.data.cost_water
            this.total4 = res.data.cost_per_cake
          }
        })
        
        
      }
    }
    submit(){
      if (this.production) {
        let data = {
              "usage_date" : this.date,
              "production_total" : parseFloat(this.production.replace(/,/g, '')),
          }
        api('kue_add',{body:data}).then(res => {
          if (res.code == 200) {
            this.$router.push('/utilities?tab=3')
          } else {
          this.$swal("Peringatan", res.data.message, "warning");
        }
      })
      .catch((err) => {
        this.$swal("Error", err?.response?.data?.message, "error");
      });
      }else{
      this.$swal("Error", "Semua field wajib diisi", "error");
    }
    }
}
</script>
